import { render, staticRenderFns } from "./ChartsPage.vue?vue&type=template&id=1abae632&scoped=true&"
import script from "./ChartsPage.vue?vue&type=script&lang=ts&"
export * from "./ChartsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChartsPage.vue?vue&type=style&index=0&id=1abae632&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abae632",
  null
  
)

export default component.exports